// ApplicationLayout.jsx

import React from "react";
import { Outlet, useSearchParams } from "react-router-dom";
import ApplicationHeader from "./components/header/ApplicationHeader";
import { ClientStatusProvider } from "../../views/context/clientContext";
import { HeaderSlotProvider } from "../../contexts/HeaderSlotContext";

export default function ApplicationLayout() {
  const [searchParams] = useSearchParams();
  const embedded = searchParams.get("embedded") === "1";

  return (
    <ClientStatusProvider>
      <HeaderSlotProvider>
      <div className="flex flex-col w-full h-screen" style={{ background: "linear-gradient(160deg,#D9D2FF 0%,#FBF7F6 45%,#FBF6F4 100%)" }}>
        {/* Header — hidden when embedded in an iframe */}
        {!embedded && <ApplicationHeader />}

        {/* Main Content */}
        <main className={`flex-1 min-h-0 overflow-y-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]`}>
          <div className={embedded ? "w-full min-h-full" : " w-full min-h-full"}>
            <Outlet />
          </div>
        </main>
      </div>
      </HeaderSlotProvider>
    </ClientStatusProvider>
  );
}
